import { useEffect } from 'react';
import { pushToDataLayer } from 'services/gtmService';
import { getPlatform } from 'helpers/getPlatform';

function useWootric(
  userId: number | undefined,
  category: string,
  userRegistrationDate: string,
  enabled?: boolean,
) {
  useEffect(() => {
    if (userId && enabled) {
      pushToDataLayer({
        userId,
        created_at: Math.round(
          Date.parse(userRegistrationDate.replace('+', 'T')) / 1000,
        ),
        category,
        platform: getPlatform(),
      });
    }
  }, [userId, enabled]);

  return;
}

export { useWootric };
